module.exports = __webpack_public_path__ + "img/David Luiz.9658e5ee.png";